<template>
    <div :class="$style.root">
        <slot></slot>
        <div class="whitespace"></div>
        <slot name="pull-right"></slot>
    </div>
</template>

<script>
    export default {
        name: 'PageTopBar',
    };
</script>

<style lang="less" module>
    @import "../styles/variables";

    .root {
        background-color: @page-body-bg-color;
        border-radius: 8px 8px 0 0;
        padding: 15px;
        margin-bottom: 10px;
        display: flex;

        :global {
            * + * {
                margin-left: 10px;
            }

            .whitespace {
                flex: 1;
                margin-left: 0;
            }

            .whitespace + * {
                margin-left: 0;
            }
        }
    }
</style>
